__turbopack_context__.v({
  "listFormation": "formation-module__xlh8-W__listFormation",
});
